module.exports = __webpack_public_path__ + "img/britishcolumbia.f21a5719.svg";